module.exports = __webpack_public_path__ + "img/comment-middle.301b91d7.svg";